import dayjs from 'dayjs';

export const formatDate = (date) => {
  if (!date) return '—';
  return dayjs(date).format('DD.MM.YYYY');
};

export const formatDateTime = (date) => {
  if (!date) return '—';
  return dayjs(date).format('DD.MM.YYYY HH:mm');
};

export const toApiDate = (date) => {
  if (!date) return null;
  return dayjs(date).toISOString();
};

export const isPastDate = (date) => {
  return dayjs(date).isBefore(dayjs(), 'day');
};

export const isTodayOrFuture = (date) => {
  return dayjs(date).isSame(dayjs(), 'day') || dayjs(date).isAfter(dayjs(), 'day');
};
